import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import emailjs from "emailjs-com";
import StatusReportHeader from "./StatusReportHeader";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

function StatusReportContainer(props) {
  const [localWait, setLocalWait] = useState(false);
  const widget_10_index = props.panelArray.findIndex((elem) => elem.id == 10);
  const dbConfigString = sessionStorage.getItem("dashboardConfig");
  if (dbConfigString) {
    const dbConfig = JSON.parse(dbConfigString);
    let metricsFound = false;
    let newDbConfig = [];
    dbConfig.forEach((widget) => {
      // only allow one project metric in status report
      if (
        widget.id != "widget_5" &&
        widget.id != "widget_6" &&
        widget.id != "widget_7"
      ) {
        newDbConfig.push(widget);
      } else {
        if (!metricsFound) {
          newDbConfig.push(widget);
          metricsFound = true;
        }
      }
    });

    newDbConfig.sort(widgetArraySort);

    const pdfBlob = useRef();
    const imgData = useRef();
    /*useEffect(() => {
      const input = document.getElementById("divToPrint");
      html2canvas(input, { scale: 0.9 }).then((canvas) => {
        imgData.current = canvas.toDataURL("image/png");
        const pdf = new jsPDF();
        pdf.addImage(imgData.current, "JPEG", 1, 0, 0, 0, undefined, "FAST");
        // pdf.output('dataurlnewwindow');
        //pdf.save("download.pdf");

        pdfBlob.current = pdf.output("datauristring");
      });
    }, []);*/

    const handleSend = () => {
      setLocalWait(true);
      const input = document.getElementById("divToPrint");
      html2canvas(input, { scale: 0.9 }).then((canvas) => {
        imgData.current = canvas.toDataURL("image/png");
        //const pdf = new jsPDF();
        var imgWidth = 210;
        var pageHeight = 295;
        var imgHeight = (canvas.height * imgWidth) / canvas.width;
        var heightLeft = imgHeight;
        var position = 10;
        var pdf = new jsPDF("p", "mm");

        pdf.addImage(
          imgData.current,
          "JPEG",
          0,
          position,
          imgWidth,
          imgHeight,
          undefined,
          "FAST",
        );
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          position += heightLeft - imgHeight; // top padding for other pages
          pdf.addPage();
          pdf.addImage(
            imgData.current,
            "JPEG",
            0,
            position,
            imgWidth,
            imgHeight,
            undefined,
            "FAST",
          );
          heightLeft -= pageHeight;
        }
        /*
        pdf.addImage(
          imgData.current,
          "JPEG",
          2,
          0,
          canvas.width / 8,
          canvas.height / 8,
          undefined,
          "FAST",
        );
        */
        // pdf.output('dataurlnewwindow');
        //pdf.save("download.pdf");

        pdfBlob.current = pdf.output("datauristring");

        const projectObject = JSON.parse(
          sessionStorage.getItem("projectObject"),
        );
        const projectTeam = projectObject.oada_project_team__c;
        if (projectTeam) {
          const teamArray = projectTeam.split(";");
          let recipients = "";
          for (let i = 0; i < teamArray.length; i++) {
            const memberAttributesArray = teamArray[i].split("|");
            if (memberAttributesArray[6] == "1") {
              recipients == ""
                ? (recipients = memberAttributesArray[2])
                : (recipients += "," + memberAttributesArray[2]);
            }
          }

          let emailParams = {
            reply_to: "noreply@addolution.com",
            from_email: "system@addolution.com",
            to_email: recipients,
            message: "Attached is the project status report.",
            subject: "Status report",
            status_report_pdf: pdfBlob.current,
          };

          const emailSettingsString = projectObject.oada_status_email_config__c;
          if (emailSettingsString) {
            const emailSettings = emailSettingsString.split(":|:");
            emailParams = {
              reply_to: emailSettings[2],
              from_email: "system@addolution.com",
              to_email: recipients,
              message: emailSettings[1],
              subject: emailSettings[0],
              invoice_pdf: pdfBlob.current,
            };
          }
          //console.log("emailParams: " + JSON.stringify(emailParams));
          emailjs
            .send(
              "service_c7r1bnm",
              "template_eol9e7r",
              emailParams,
              "2FHJMHf8TQu-Ag783",
            )
            .then(
              (response) => {
                console.log("SUCCESS!", response.status, response.text);
                console.log("length: " + pdfBlob.current.length);
                alert("Status report sent successfully");
                setLocalWait(false);
                props.handleClose();
              },
              (error) => {
                console.log("FAILED...", error);
                console.log("length: " + pdfBlob.current.length);
                alert("Error sending status report: " + error);
                setLocalWait(false);
                props.handleClose();
              },
            );
        }
      });
    };
    return (
      <Box>
        <Backdrop
          sx={{ color: "#fff", position: "absolute", zIndex: 10 }} //, zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={localWait}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Box sx={{ width: "820px", textAlign: "center" }}>
          <Button className="dialogConfirmCancelButton" onClick={handleSend}>
            Send
          </Button>
          <Button
            className="dialogConfirmCancelButton"
            onClick={props.handleClose}
          >
            Close
          </Button>
          <hr></hr>
          <div id="divToPrint">
            <Box display="flex" justifyContent="space-around">
              <div>
                <StatusReportHeader />
              </div>
              {/* project team */}
              <div>{props.panelArray[widget_10_index].statusContent(0)}</div>
            </Box>
            <Box sx={{ textAlign: "center" }}>
              {newDbConfig.map((elem, index) => {
                if (elem.id != "widget_10") {
                  return props.panelArray
                    .find((masterElem) => elem.id == "widget_" + masterElem.id)
                    .statusContent(index);
                }
              })}
            </Box>
          </div>
        </Box>
      </Box>
    );
  }
}

function widgetArraySort(a, b) {
  return a.row * 10 + a.col - (b.row * 10 + b.col); // sorts left to right
  //return a.col * 10 + a.row - (b.col * 10 + b.row); // sorts top to bottom
}
export default StatusReportContainer;

StatusReportContainer.propTypes = {
  waitHandler: PropTypes.func,
  panelArray: PropTypes.array,
  handleClose: PropTypes.func,
};

/*
{props.panelArray.map((elem, index) => elem.statusContent(index))}
*/
